import { useLingui } from "@lingui/react/macro";
import { ArrowLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { WindowChrome } from "../pages/WindowChrome";
import { LoadingState } from "./ai/primitives";

/** Session checks and lazy page loads must never impersonate a different destination. */
export function RouteLoadingState() {
  const { pathname } = useLocation();
  const { t } = useLingui();
  const title = pathname.startsWith("/app/artifacts")
    ? t`Files`
    : pathname === "/app/editor"
      ? t`Text Editor`
      : pathname === "/app/mission-briefing"
        ? t`Mission Briefing`
        : undefined;
  return (
    <div
      className="app-canvas flex h-full flex-col bg-background"
      data-rakazo-app-state="session-pending"
    >
      {title && (
        <header className="app-drag flex h-16 shrink-0 items-center gap-3 px-5">
          <WindowChrome />
          <Link
            to="/app"
            className="app-no-drag flex items-center gap-1 text-[13px] text-muted-foreground"
          >
            <ArrowLeft size={15} />
            {t`Home`}
          </Link>
          <h1 className="text-lg font-semibold">{title}</h1>
        </header>
      )}
      <div className="grid min-h-0 flex-1 place-items-center">
        <LoadingState label={t`Loading…`} />
      </div>
    </div>
  );
}
